import React from 'react';
import illustration from '../../../../../../../assets/img/Illustration.png';

const ModalIllustration = () => {
  return (
    <div className="modal-illustration-wrapper">
      <img className="modal-illustration-img" src={illustration} alt="event" />
    </div>
  );
};

export default ModalIllustration;
